export default () => ({
    mobileMenuVisible: false,
    headerNavigation: {},
    footerMainNavigation: [],
    footerLinksNavigation: {},
});
